<template>
  <SfScrollable
    class="m-auto w-full items-start py-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    buttons-placement="floating"
    drag
    tabindex="-1"
  >
    <template #previousButton="defaultProps">
      <SfButton
        v-bind="defaultProps"
        class="absolute left-4 z-[9] hidden size-10 !rounded-full bg-white p-0 !text-neutral-900 hover:!bg-neutral-100 md:block"
        :class="[{ '!hidden': defaultProps.disabled }, previousButtonClass]"
        variant="secondary"
        size="base"
        :aria-label="$t('Previous')"
        square
      >
        <SfIconChevronLeft
          class="!block"
        />
      </SfButton>
    </template>
    <slot />
    <template #nextButton="defaultProps">
      <SfButton
        v-bind="defaultProps"
        class="absolute right-4 z-[9] hidden size-10 !rounded-full bg-white p-0 !text-neutral-900 hover:!bg-neutral-100 md:block"
        :class="[{ '!hidden': defaultProps.disabled }, nextButtonClass]"
        variant="secondary"
        size="base"
        :aria-label="$t('Next')"
        square
      >
        <SfIconChevronRight
          class="!block"
        />
      </SfButton>
    </template>
  </SfScrollable>
</template>

<script lang="ts" setup>
import {
  SfButton,
  SfScrollable,
  SfIconChevronLeft,
  SfIconChevronRight,
} from '@storefront-ui/vue';

defineComponent({ name: 'SfCarousel' });

defineProps({
  previousButtonClass: undefined,
  nextButtonClass: undefined,
});
</script>
